<div
  data-at-loader
  *ngIf="isLoading"
  class="vi-loader flex flex-col gap-[25px] justify-center items-center"
  [class.vi-orange-theme]="viOrangeTheme"
  [class.size-large]="size === 'large'"
>
  <div class="progress-spinner">
    <div *ngIf="viOrangeTheme" class="spinner-background"></div>
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  <div class="message flex flex-col gap-[12px] justify-center items-center">
    <div class="message-loading">{{ titleKey | translate }}</div>
    <div data-at-loader-message class="message-description">
      {{ message | translate }}
    </div>
  </div>
</div>
